import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography } from '@mui/material';
import { NgDialog } from '../NgDialog/NgDialog';

interface Slide {
  id: number;
  title: string;
  thumbnail: string;
}

interface ThemeData {
  id?: number;
  name?: string;
  displayName?: string;
  description?: string;
  slides?: Slide[];
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any; // Allow additional properties from FolderManagerItem
}

interface ManageThemeDialogProps {
  open: boolean;
  onClose: () => void;
  themeData: ThemeData;
  onSave: (updatedTheme: ThemeData) => void;
}

export const ManageThemeDialog: React.FC<ManageThemeDialogProps> = ({ open, onClose, themeData, onSave }) => {
  const itemName = themeData?.displayName || themeData?.name || 'Untitled Theme';
  const itemDescription = themeData?.description || '';

  const [name, setName] = React.useState(itemName);
  const [description, setDescription] = React.useState(itemDescription);

  const handleSave = () => {
    onSave({
      ...themeData,
      name,
      description,
    });
  };

  return (
    <NgDialog opened={open} title="Manage Theme" onDismiss={onClose}>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Theme Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
          />

          <p>@todo: Is Default theme</p>

          {themeData.slides && themeData.slides.length > 0 && (
            <>
              <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
                Slides ({themeData.slides.length})
              </Typography>

              {/* <Grid container spacing={2}>
                {themeData.slides.map((slide) => (
                  <Grid item xs={12} sm={6} md={4} key={slide.id}>
                    <Box
                      sx={{
                        border: '1px solid #ddd',
                        borderRadius: 1,
                        p: 2,
                        textAlign: 'center',
                      }}
                    >
                      <img
                        src={slide.thumbnail}
                        alt={slide.title}
                        style={{ width: '100%', height: 'auto', borderRadius: 4 }}
                      />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        {slide.title}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid> */}
            </>
          )}

          {/* <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              Theme Data (Debug):
            </Typography>
            <Typography variant="caption" component="pre" sx={{ fontSize: '0.75rem' }}>
              {JSON.stringify(themeData, null, 2)}
            </Typography>
          </Box> */}

          {themeData.createdAt && themeData.updatedAt && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="caption" color="text.secondary">
                Created: {new Date(themeData.createdAt).toLocaleString()}
              </Typography>
              <br />
              <Typography variant="caption" color="text.secondary">
                Updated: {new Date(themeData.updatedAt).toLocaleString()}
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </NgDialog>
  );
};
